import Divider from "component/divider/divider";
import { Col, Row } from "react-bootstrap";

const NewsCustomizedContentWrapper = ({
  allowCustomization = true,
  children,
}) => {
  return false ? (
    <div>
      <div>
        <img
          className="capmas-internal-logo"
          width={"270px"}
          //height={50}
          src={process.env.PUBLIC_URL + "/image/logo.png"}
          alt="logo"
        />
      </div>
      <Divider
        borderColor="var(--main-color)"
        marginBottom={"10px"}
        marginTop={"10px"}
        borderRadius={"20px"}
      />
      {children}
      <div className="footer">
        <Divider
          borderColor="var(--main-color)"
          marginBottom={"10px"}
          marginTop={"10px"}
          borderRadius={"20px"}
        />
        <Row>
          <Col xs={4} style={{ fontSize: "11px", textAlign: "start" }}>
            <Row>
              <Col xs={12} style={{ fontWeight: "bold" }}>
                الجـــــهاز المركـــــزي للتعبئــــة العامــــــة
                والإحصـــــــاء
              </Col>
              <Col xs={12} style={{ fontSize: "11px" }}>
                صلاح سالم، مدينة نصر، القاهرة، مصر – ص.ب. 2086
              </Col>
            </Row>
          </Col>
          <Col xs={4} style={{ fontSize: "11px", textAlign: "center" }}>
            <Row>
              <Col xs={12}>www.capmas.gov.eg</Col>
              <Col xs={12}>ContactUs@capmas.gov.eg</Col>
              <Col xs={12}>+202-24002718</Col>
            </Row>
          </Col>
          <Col xs={4} style={{ fontSize: "11px", textAlign: "end" }}>
            <Row>
              <Col xs={12} style={{ fontWeight: "bold" }}>
                Central Agency for Public Mobilization and Statistics
              </Col>
              <Col xs={12}>
                Salah Salem St. Nasr City, Cairo, Egypt – PO Box 2086
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
    </div>
  ) : (
    <div>{children}</div>
  );
};

export default NewsCustomizedContentWrapper;
